import React, { useContext, useEffect } from 'react'
import Introsection from '../../organisms/Homesections/Introsection/Introsection'
import Addedrecently from '../../organisms/Homesections/Addedrecentlysection/Addedrecently'
import Newssection from '../../organisms/Homesections/Newssections/Newssection'
import Videossection from '../../organisms/Homesections/Videossections/Videossection'
import Statisticssection from '../../organisms/Homesections/Statisticssections/Statisticssection'
import Searchsection from '../../organisms/Homesections/Searchsections/Searchsection'
import Mapsection from '../../organisms/Homesections/Mapsections/Mapsection'
import Footer from '../../organisms/Footersections/Footer'
import { AppContext } from '../../../services/Appcontext'
import { useTranslation } from 'react-i18next'



const videos = [
  // { src: "https://www.w3schools.com/html/mov_bbb.mp4", title: "وزارة الثقافة تدرج أسماء شهداء الاطقم الطبية بمشروع عاش هنا تخليدا لدورهم ا الوطني" },
  { src: "https://www.youtube.com/embed/sjo6ajQ6uTs", title: "وزارة الثقافة تدرج أسماء شهداء الاطقم الطبية بمشروع عاش هنا تخليدا لدورهم ا الوطني" },
  { src: "https://www.youtube.com/embed/TfiiLdWfCak", title: "Sample Video 2" },
  { src:"https://www.youtube.com/embed/Od6LJhVvNOI?list=RDEMzczDcxBoaRuzqJSb2Z75DA" , title: "Sample Video 3" },
];

export default function Homepage() {
  const { addedRecently,getAddedRecently,
          latestNews, getLatestNews,
          allVideos, getAllVideos,
          stas,getStas,
          characterSlider,getCharacterSlider,

        }=  useContext(AppContext)
  const { i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";
  useEffect(()=>{
    getLatestNews()
    getAllVideos()
    getStas()
    // console.log("hereeeee")
    getAddedRecently(5)
    getCharacterSlider(10)
  },[])
  // console.log("Home Data",addedRecently?.data)
  // console.log("Home Data",characterSlider.data)
  
  // const mapLink = "https://www.google.com/maps/embed?pb=..."
  const mapLink = isArabic
    ? "https://storymaps.arcgis.com/stories/5e096a765a5f4605b71c97c5fd69dadb?locale=ar"
    : "https://storymaps.arcgis.com/stories/a3fdd3dbfeb4460f8986909f0b1c8b57"


  return (
    <div>
    {characterSlider.loading? console.log("is loading..."): 
      <Introsection data={characterSlider.data}/>
    }
      {addedRecently.loading? console.log("is loading..."): 
      
          <Addedrecently data={addedRecently?.data}/>
      }

      {latestNews.loading? console.log("is loading..."): 

          <Newssection data={latestNews.data}/>
      }

      {allVideos.loading? console.log("is loading..."): 
        allVideos.data === undefined || allVideos.data?.length!==0 ?
          <Videossection  videos={allVideos.data}/>
        :null
      }

      {stas.loading? console.log("is loading..."): 

          <Statisticssection data={stas.data}/>
      }

      {/* <Searchsection/> */}
      <Mapsection mapLink={mapLink} height={'md:h-[550px]'}/>
      <Footer/>
    </div>
  )
}
